// activity.jsx — versioned local reading history. This is intentionally behind
// a tiny API so it can be replaced by account sync without changing the UI.
(function () {
  const KEY = "mayanos.activity.v1";
  const LIMIT = 250;

  function read() {
    try {
      const parsed = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.ref).slice(0, LIMIT) : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items.slice(0, LIMIT))); } catch (e) {}
    try { window.dispatchEvent(new Event("mayanos-activity")); } catch (e) {}
    if (window.MAYANOS_ACCOUNT_SYNC) window.MAYANOS_ACCOUNT_SYNC.schedule();
  }

  function record(text) {
    if (!text || !text._liveRef) return;
    const items = read();
    const previous = items.find((item) => item.ref === text._liveRef) || {};
    const entry = {
      ref: text._liveRef,
      title: text.titleEn || text._liveRef,
      heTitle: text.titleHe || "",
      collection: text.collection || "",
      progress: Number(previous.progress) || 0,
      lastPosition: Number(previous.lastPosition) || 0,
      lastSegmentRef: previous.lastSegmentRef || "",
      updatedAt: Date.now(),
    };
    write([entry].concat(items.filter((item) => item.ref !== entry.ref)));
  }

  function update(ref, progress, lastSegmentRef) {
    if (!ref) return;
    const items = read();
    const index = items.findIndex((item) => item.ref === ref);
    if (index < 0) return;
    const current = items[index];
    const value = Math.max(0, Math.min(1, Number(progress) || 0));
    items[index] = {
      ...current,
      progress: Math.max(Number(current.progress) || 0, value),
      lastPosition: value,
      lastSegmentRef: lastSegmentRef || current.lastSegmentRef || "",
      updatedAt: Date.now(),
    };
    write([items[index]].concat(items.filter((_, itemIndex) => itemIndex !== index)));
  }

  function cards() {
    return read().slice(0, 3).map((item) => ({
      id: item.ref,
      ref: item.ref,
      he: item.heTitle || item.title,
      en: item.title,
      coll: item.collection,
      progress: Number(item.progress) || 0,
      lastSegmentRef: item.lastSegmentRef || "",
      open: true,
    }));
  }

  function replace(items) { write(Array.isArray(items) ? items : []); }

  window.MAYANOS_ACTIVITY = { read, record, update, replace, cards };
  window.CONTINUE = cards();
})();
